<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>修改品牌折扣 - {{serv.groupName}} </el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search"></el-form>
		<el-form label-width="120px" :model="serv" ref="serv">
			<el-form-item label="名称" prop="name">
				<el-input size="small" disabled v-model="serv2.groupName" auto-complete="off" placeholder="请输入品牌名称">
				</el-input>
			</el-form-item>
			<el-form-item label="差价" prop="name">
				<el-input size="small" disabled v-model="serv2.rateBase1" auto-complete="off" placeholder=""></el-input>
			</el-form-item>
			<el-form-item label="储值金额" prop="name">
				<el-input type="number" size="small" v-model="serv2.czAmount" auto-complete="off" placeholder=""></el-input>
			</el-form-item>
			<el-form-item label="实际获得金额" prop="name">
				<el-input type="number" size="small" v-model="serv2.useAmount" auto-complete="off" placeholder=""></el-input>
			</el-form-item>
			<el-form-item label="折扣" prop="name">
				<el-input type="number" size="small" v-model="serv2.rateBase" auto-complete="off" placeholder="请输入预存折扣"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer" style="display: flex; justify-content: center;">
			<el-button size="small" @click="$router.back(-1)">取消</el-button>
			<el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存
			</el-button>
		</div>
	</div>
</template>

<script>
	import {
		getMerchantGroupDetail,
		updateGroupDiscount
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	export default {
		data() {
			return {
				xg1: 0,
				editForm: {
					bank_info: '',
					branch_name: '',
					bank_id: '',
					token: localStorage.getItem('logintoken')
				},
				title: '添加',
				province1: [],
				province_code: '',
				city1: [],
				city_code: '',
				bankCode: '',
				branchlist: [],
				bank_id: '',
				mchId: this.$route.query.id,
				serv: '',
				serv2: '',
				bankCardNo: ''
			}
		},
		// 注册组件
		components: {
			Pagination
		},
		created() {
			this.merchantDetail()
		},
		methods: {
			xzg() {
				this.serv2.rateBase1 = ((this.serv2.czAmount / this.serv2.useAmount) * 100).toFixed(0)
				console.log(this.serv2.rateBase)
			},
			merchantDetail() {
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					"groupId": this.mchId
				}
				getMerchantGroupDetail(pro).then(res => {
					if (res.data.bankInfo) {
						res.data.bankInfo1 = res.data.bankInfo.split('|')
					} else {
						res.data.bankInfo1 = ['', '', '', '']
					}
					this.serv = JSON.parse(JSON.stringify(res.data))
					this.serv2 = JSON.parse(JSON.stringify(res.data))
					this.xzg()
				})
			},
			submitForm() {
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					fundsId: this.mchId,
					czAmount: this.serv2.czAmount,
					useAmount: this.serv2.useAmount,
					rateBase: this.serv2.rateBase,
				}
				updateGroupDiscount(pro).then((res) => {
					if (res.code == 0) {
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.$router.push({
							name: '品牌管理'
						})
					} else {
						this.$message({
							type: 'info',
							message: res.msg
						})
					}
				})
			}

		}
	}
</script>

<style scoped>
	.user-search {
		margin-top: 20px;
	}

	.userRole {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/group/groupdiscount.vue